(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["apel-awards-news"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-apel-slider]').forEach((slider) => {
    const slides = Array.from(slider.querySelectorAll('[data-slide]'));
    const dotsRoot = slider.querySelector('[data-slider-dots]');
    const currentLabel = slider.querySelector('[data-slider-current]');
    if (!slides.length) return;
    if (slides.length < 2 || !dotsRoot) {
      if (currentLabel) currentLabel.textContent = '01';
      return;
    }
    let current = 0;
    let timer;
    const dots = slides.map((_, index) => {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.setAttribute('aria-label', `Show slide ${index + 1}`);
      dot.addEventListener('click', () => show(index, true));
      dotsRoot.appendChild(dot);
      return dot;
    });
    const show = (index, restart = false) => {
      current = (index + slides.length) % slides.length;
      slides.forEach((slide, slideIndex) => slide.classList.toggle('is-active', slideIndex === current));
      dots.forEach((dot, dotIndex) => dot.classList.toggle('is-active', dotIndex === current));
      if (currentLabel) currentLabel.textContent = String(current + 1).padStart(2, '0');
      if (restart) start();
    };
    const start = () => {
      window.clearInterval(timer);
      const interval = Number(slider.dataset.interval) || 6000;
      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) timer = window.setInterval(() => show(current + 1), interval);
    };
    slider.querySelector('[data-slider-prev]')?.addEventListener('click', () => show(current - 1, true));
    slider.querySelector('[data-slider-next]')?.addEventListener('click', () => show(current + 1, true));
    slider.addEventListener('mouseenter', () => window.clearInterval(timer));
    slider.addEventListener('mouseleave', start);
    show(0);
    start();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["apel-blog"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-blog-library] details').forEach((article) => {
    article.addEventListener('toggle', () => {
      if (!article.open) return;
      document.querySelectorAll('[data-blog-library] details[open]').forEach((other) => {
        if (other !== article) other.open = false;
      });
      const id = article.id;
      if (id) window.history.replaceState(null, '', `#${id}`);
      const articleBody = article.querySelector('.blog-article');
      if (articleBody) {
        window.requestAnimationFrame(() => {
          articleBody.scrollIntoView({ behavior: 'auto', block: 'start' });
        });
      }
    });
  });

  const requestedArticle = window.location.hash ? document.querySelector(window.location.hash) : null;
  if (requestedArticle?.matches('[data-blog-library] details')) requestedArticle.open = true;

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["apel-home"] && !Shopify.designMode) return;
  try {
    
  const initializeWelcomeSliders = (root = document) => {
    root.querySelectorAll('[data-welcome-slider]:not([data-welcome-ready])').forEach((slider) => {
      slider.setAttribute('data-welcome-ready', 'true');
      const slides = Array.from(slider.querySelectorAll('[data-welcome-slide]'));
      const dots = Array.from(slider.querySelectorAll('[data-welcome-dot]'));
      const currentLabel = slider.querySelector('[data-welcome-current]');
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const autoplay = slider.dataset.welcomeAutoplay !== 'false';
      let current = Math.max(0, slides.findIndex((slide) => slide.classList.contains('is-active')));
      let timer;

      const stop = () => window.clearTimeout(timer);
      const updateVideo = (slide, active) => {
        const video = slide.querySelector('video');
        if (!video) return;
        if (active && !reduceMotion.matches) {
          video.play().catch(() => {});
        } else {
          video.pause();
        }
      };
      const schedule = () => {
        stop();
        if (!autoplay || slides.length < 2 || reduceMotion.matches || document.hidden) return;
        const duration = Number(slides[current]?.dataset.duration) || 5000;
        timer = window.setTimeout(() => show(current + 1), duration);
      };
      const show = (index, restart = true) => {
        current = (index + slides.length) % slides.length;
        slides.forEach((slide, slideIndex) => {
          const active = slideIndex === current;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', String(!active));
          updateVideo(slide, active);
        });
        dots.forEach((dot, dotIndex) => {
          const active = dotIndex === current;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-selected', String(active));
        });
        if (currentLabel) currentLabel.textContent = String(current + 1).padStart(2, '0');
        if (restart) schedule();
      };

      dots.forEach((dot) => dot.addEventListener('click', () => show(Number(dot.dataset.slideTarget))));
      slider.querySelector('[data-welcome-prev]')?.addEventListener('click', () => show(current - 1));
      slider.querySelector('[data-welcome-next]')?.addEventListener('click', () => show(current + 1));
      slider.addEventListener('mouseenter', stop);
      slider.addEventListener('mouseleave', schedule);
      slider.addEventListener('focusin', stop);
      slider.addEventListener('focusout', schedule);
      document.addEventListener('visibilitychange', schedule);
      reduceMotion.addEventListener?.('change', () => show(current));
      slider.addEventListener('shopify:block:select', (event) => {
        const selected = event.target.closest('[data-welcome-slide]');
        if (selected) show(slides.indexOf(selected), false);
        stop();
      });

      show(current);
    });
  };

  initializeWelcomeSliders();
  document.addEventListener('shopify:section:load', (event) => initializeWelcomeSliders(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
